import { Component, Input, OnInit } from '@angular/core';
import { ConfigurationService } from '../../../services/configuration.service'
import { redirectCta, RestrictionTypes } from '../../enums/subscription.enum';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'access-restriction-popup',
  templateUrl: './access-restriction-popup.component.html',
  styleUrls: ['./access-restriction-popup.component.scss'],
  standalone: false
})

export class AccesRestrictionPopupComponent implements OnInit {
  restrictionTypeTitle: string = '';
  actionMsg1: string = '';
  actionMsg2: string = '';
  actionBtnlabel: string = '';
  supportUrl: string = '';
  parnerName: string = '';
  isDialog: boolean = false;
  applyCustomDialogStyles: boolean = false;
  defaultDialogStyles: boolean = false;
  emailContent:any = '';
  @Input() siteBillingAdmins: any;
  @Input() isBillingAdmin: boolean = false;
  @Input() componentName: string = '';
  @Input() restrictionType: string = '';
  @Input() userInfo: any = {}
  
  constructor(private configService: ConfigurationService) { }

  ngOnInit() {
    this.initializeData();
  }

  // Method to initialize the data based on the input properties of the component.
  initializeData() {
    this.isDialog = true; // flag to displaying the popup as dialog with overlay
    this.defaultDialogStyles = true // flag to set the default styles for popup when displayed as a dialog with overlay or as a card in components in componentsWithOnlyPadding array.    

    let billingAdmins = [];
    let emailSubject = '';
    let emailBody = '';
    let siteName = this.userInfo?.siteName;
    let userName = this.userInfo?.userName;

    if (!this.isBillingAdmin) {
      billingAdmins = this.siteBillingAdmins?.map((admin:any) => admin?.emailId);
    }
    
    if (this.restrictionType == RestrictionTypes.Tier_Upgrade) {
      this.restrictionTypeTitle = 'Tier Upgrade Required';
      this.actionMsg1 = "is available in a higher subscription tier.";
      this.actionMsg2 = "Please upgrade your site's subscription to unlock this feature.";
      this.actionBtnlabel = redirectCta.UpgradeNow;

      if (!this.isBillingAdmin) {
        emailSubject = encodeURIComponent(`Upgrade Plan for Full Access to ${siteName}’s Features!`);
        emailBody = encodeURIComponent(
          `Hi,

The site "${siteName}" is currently on a lower subscription tier and requires an upgrade to access the full set of features. To ensure uninterrupted service and unlock the full range of capabilities, please consider upgrading the subscription to a higher tier.
          


Thank you for your support.
Best regards,
${userName}`
        );
        this.emailContent = `mailto:${billingAdmins}?subject=${emailSubject}&body=${emailBody}`
      }
    } else if (this.restrictionType == RestrictionTypes.Payment_Due) {
      this.restrictionTypeTitle = 'Payment Due';
      this.actionMsg1 = "Your access to site has been suspended as the outstanding balance remains unpaid beyond the allowed grace period.";
      this.actionMsg2 = "Please complete your payment to restore access.";
      this.actionBtnlabel = redirectCta.RenewNow;
      this.applyCustomDialogStyles = true;
      if (!this.isBillingAdmin) {
        emailSubject = encodeURIComponent(`Payment Reminder for ${environment.productName} Software Subscription`);
        emailBody = encodeURIComponent(
          `Hi,

Just a quick reminder that the payment for the "${siteName}" subscription is still overdue. Can you please look into this and process the payment as soon as possible? We want to make sure there’s no disruption in service, and the full set of features remains available to the team.

Thanks so much for your help with this!



Thank you for your support.
Best regards,
${userName}`
        );
        this.emailContent = `mailto:${billingAdmins}?subject=${emailSubject}&body=${emailBody}`;
      }
    } else if (this.restrictionType == RestrictionTypes.Add_On_Feature) {
      this.restrictionTypeTitle = 'Add-On Feature';
      this.actionMsg1 = "is an add on not included in your current subscription";
      this.actionMsg2 = "Please enable this add on to gain access.";
      this.actionBtnlabel = redirectCta.EnableAddOn;

      if (!this.isBillingAdmin) {
        emailSubject = encodeURIComponent(`Request to Enable ${this.componentName} Add-On`);
        emailBody = encodeURIComponent(
          `Hi,

I’m reaching out to request the activation of the ${this.componentName} add-on for our site, "${siteName}". This feature is really important for supporting our operations and improving overall performance.

Thanks so much for your help with this—let me know if you need any more details from my side! 



Thank you for your support. 
Best regards, 
${userName}`
        );
        this.emailContent = `mailto:${billingAdmins}?subject=${emailSubject}&body=${emailBody}`
      }
    } else if (this.restrictionType == RestrictionTypes.canceled) {
      this.restrictionTypeTitle = 'Subscription Canceled';
      this.actionMsg1 = "Your access to this site has been suspended due to the cancelation of the subscription plan.";
      this.actionMsg2 = "Please reactivate your subscription to restore access.";
      this.actionBtnlabel = redirectCta.ReactivateNow;
      this.applyCustomDialogStyles = true;

      if (!this.isBillingAdmin) {
        emailSubject = encodeURIComponent(`Subscription Plan Canceled for ${siteName}`);
        emailBody = encodeURIComponent(
          `Hi,

Subscription plan for the site "${siteName}" has been canceled. Can you please look into this and take any necessary action to restore access?  We want to make sure there’s no disruption in service, and the full set of features remains available to the team.

Thanks so much for your help with this!



Thank you for your support.
Best regards,
${userName}`
        );
        this.emailContent = `mailto:${billingAdmins}?subject=${emailSubject}&body=${emailBody}`;
      }
    }

    // Mock data
    this.supportUrl = this.configService.getConfig('helpCenter');
    this.parnerName = this.configService.getConfig('partnerName');
  }
  
  // Method to handle the action button click event to upgrade or renew the subscription.
  onButtonClick() {
    window.parent.postMessage(JSON.stringify({redirectSubDetailsPage:true}), '*');
  }
  
   
}
